<template>
  <v-layout
    v-if="!$apollo.loading"
    justify-center
    wrap
  >
    <v-flex
      v-if="!_.isEmpty(userBots)"
      md12
    >
      <v-card>
        <v-data-table
          :headers="headers"
          :items="userBots"
          :hide-default-footer="true"
          :mobile-breakpoint="900"
          :items-per-page="200"
        >
          <template
            slot="headerCell"
            slot-scope="{ header }"
          >
            <span v-text="header.text" />
          </template>
          <template v-slot:item.logo="{ item }">
            <v-avatar
              :tile="false"
              :size="40"
            >
              <v-img
                :src="(item.bot.logo || require('@/images/no-image.png'))"
                :lazy-src="item.bot.logo"
                max-height="40"
                contain
              />
            </v-avatar>
          </template>
          <template v-slot:item.account_name="{ item }">
            <router-link :to="'/traderbots/mybot/' + item.id">
              <b>{{ item.account_name }}</b>
              <br>
            </router-link>

            <small>{{ item.bot.exchange }}</small>
          </template>
          <template v-slot:item.description="{ item }">
            <template>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ item.bot.description }}
              </v-tooltip>
              <span style="margin-top:4px;">{{ item.bot.name }}</span>
            </template>
          </template>
          <template v-slot:item.manager="{ item }">
            <div
              v-if="item.manager !== null"
              class="connected_manager"
            >
              <b>{{ item.manager.name }}</b>
              <span v-if="item.manager !== null && item.manager.connection_status == 'pending'">
                - {{ $t('globals.pending') }}
                <template>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-information-outline</v-icon>
                    </template>
                    {{ $t('bots.pendingTooltip1') }}
                    <b>{{ item.manager.request_sent | moment('L') }}</b>
                    .
                    {{ $t('bots.pendingTooltip2') }}
                  </v-tooltip>
                </template>
              </span>
              <span v-if="item.manager !== null && item.manager.connection_status == 'declined'">
                -
                <b>{{ $t('globals.declined') }}</b>
                <template>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-information-outline</v-icon>
                    </template>
                    {{ $t('bots.declinedTooltip') }}
                  </v-tooltip>
                </template>
              </span>
            </div>
            <div v-else>
              {{ $t('globals.no') }}
            </div>
          </template>
          <template v-slot:item.activated_till="{ item }">
            {{ item.activated_till | moment("L") }}
          </template>
          <template v-slot:item.status="{ item }">
            <b :class="colorStatus(item.status)">{{ $t('globals.'+item.status) }}</b>
            <v-progress-linear
              v-if="item.status == 'installing'"
              color="deep-purple accent-4"
              indeterminate
              rounded
              height="3"
            />
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              :disabled="item.status == 'installing'"
              outlined
              text
              small
              @click="$router.push('/traderbots/mybot/' + item.id)"
            >
              {{ $t('bots.viewButton') }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <v-flex
      v-else
      md5
      xs12
      new-record
      mt-5
    >
      <v-card style="padding:50px">
        <component :is="newIcon" />
        <h3>{{ $t('bots.myTradingBots') }}</h3>
        <p>{{ $t('bots.notFoundMyBots') }}</p>
        <v-btn
          class="primary"
          @click="$emit('changeTab', 'allbots')"
        >
          {{ $t('bots.viewBotsButton') }}
        </v-btn>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
const USER_BOTS_QUERY = require("@/graphql/queries/UserBots.gql");
import IconBots from "@/components/icons/IconBots.vue";
export default {
  name: "UserBots",
  data() {
    return {
      loading: false,
      newIcon: IconBots,
      headers: [
        {
          sortable: false,
          text: "",
          value: "logo"
        },
        {
          sortable: false,
          text: this.$t("bots.accountName"),
          value: "account_name"
        },
        {
          sortable: false,
          text: this.$t("globals.description"),
          value: "description"
        },
        {
          sortable: false,
          text: this.$t("globals.status"),
          value: "status"
        },
        {
          sortable: false,
          text: this.$t("bots.aum"),
          value: "manager"
        },
        {
          sortable: false,
          text: this.$t("bots.activeTill"),
          value: "activated_till"
        },
        {
          sortable: false,
          text: "",
          value: "actions"
        }
      ]
    };
  },
  apollo: {
    userBots: {
      query: USER_BOTS_QUERY,
      fetchPolicy: "network",
      pollInterval: 20 * 1000
    }
  },
  beforeDestroy() {
    this.$apollo.queries.userBots.stopPolling();
  }
};
</script>
<style lang="scss" scoped>
h2 {
  display: inline-block;
}
.btn-project {
  float: right;
  margin: 20px 0 10px;
}
.ticker {
  font-weight: 700;
  color: #9c27b0;
}
.name {
  font-weight: 600;
  color: #7f97ab;
}
.v-avatar {
  margin: 10px 0;
}
</style>
